import React from 'react';
import { DocumentIcon } from '../../Icons';
import { Nullable, SearchItemViewModel, SearchMeta } from '../types';
import { convertToBillingUrl } from '../../../nav/utils/getBillingBaseUrl';

const chipStates = {
  Draft: 'default',
  Generating: 'primary',
  Error: 'error',
  Posted: 'success',
  Canceled: 'error',
  CancelInProgress: 'warning',
  PendingForTax: 'default',
};

function renderItem(invoice, t): Nullable<SearchItemViewModel> {
  return {
    title: invoice['InvoiceNumber'],
    descriptionFields: [
      {
        type: 'Text',
        value: invoice['Account.Name'],
        title: invoice['Account.Name'],
      },
      {
        type: 'Text',
        value: invoice['Account.AccountNumber'],
        title: invoice['Account.AccountNumber'],
      },
      {
        type: 'Date',
        value: invoice['InvoiceDate'],
        title: t('Invoice.InvoiceDate'),
      },
      {
        type: 'Currency',
        value: invoice['Balance'],
        title: t('Invoice.Balance'),
        currency: invoice['Currency.Code'],
      },
    ],
    chipField: {
      label: t(`Invoice.Status.${invoice['Status']}`),
      state: chipStates[invoice['Status']],
    },
    href: convertToBillingUrl(
      `/apps/NewInvoice.do?method=view&invoiceKey=${invoice['InvoiceNumber']}`,
    ),
  };
}

export const Invoice: SearchMeta = {
  objectType: 'Invoice',
  objectLabelI18n: 'Invoice.TabLabel',
  needsPermission: false,
  tabIcon: <DocumentIcon />,
  listPageUrl: convertToBillingUrl('/apps/NewInvoice.do'),
  hasAdvancedSearch: true,
  renderItem,
};
